import React from 'react';
import styled from 'styled-components';

const List = ({ items, lineheight, checkmark, margin }) => {
    let StyledList;
    if (checkmark === true) {
        StyledList = styled.ul`
            list-style-type: none;
            margin: ${margin || 0};
            padding: 0 ${props => props.theme.space[1]};
            line-height: ${lineheight || 'inherit'};
    
            & li:before {
              content: "\\2713 \\0020";
              font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
            }
    `;
    }
    else {
        StyledList = styled.ul`
            list-style-type: circle;
            margin: ${margin || 0};
            padding: 0 ${props => props.theme.space[9]};
            line-height: ${lineheight || 'inherit'};
        `;
    }

    const listItems = items.map((item, index) => <li key={index}>{item}</li>,

    );

    return (
        <StyledList key={Date.now()}>
            {listItems}
        </StyledList>
    );
};

export default List;



// WEBPACK FOOTER //
// ./src/components/List.js